import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

// components
import SectionContainer from "core/SectionContainer";
import OffsetGrid from "core/OffsetGrid";
import colors from "core/colors";
import Heading from "core/Heading";
import FormInput from "core/FormInput";
import LoadingSpinner from "core/LoadingSpinner";
import breakpoints from "core/breakpoints";

// styles
import { CheckoutPageHeading } from "subscriptions/styles";
import {
    ApplyButton,
    ButtonContainer,
    CancelLink
} from "subscriptions/NounProEdu/EduApplication/styles";

// data
import { teamNamePlaceholder, teamNumberPlaceholder } from "./data";
import { NOUN_PRO_TEAM_CHECKOUT, NOUN_PRO_TEAM_LANDING_PAGE } from "data/links";

// helpers
import { nameValidation, numValidation } from "./helpers";
import { getCsrfCookieName } from "js/helpers/gazetteGetCsrfCookieName";
import { getCookie } from "js/helpers/gazetteGetCookie";
import { useViewport } from "js/hooks/useViewport";

const TeamInfo = ({ match }) => {
    const history = useHistory();
    const { browserWidth } = useViewport();

    const { planType } = match.params;
    const [teamSeats, setTeamSeats] = useState("");
    const [teamName, setTeamName] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // We need to manually take control of the browsers scrollRestoration
        window.history.scrollRestoration = "manual";

        if (window.pageYOffset !== 0) {
            window.scrollTo(0, 0);
        }
    }, []);

    const createTeamName = async () => {
        const csrfCookieName = getCsrfCookieName();
        const csrftoken = getCookie({ name: csrfCookieName });

        setLoading(true);

        const teamNameURL = "/api/private/teams/";

        const body = { team_name: teamName };

        const options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": csrftoken
            },
            body: JSON.stringify(body)
        };

        const response = await fetch(teamNameURL, options);

        if (!response.ok) {
            setLoading(false);
            return;
            // TODO: need better error handling here
        }

        response.json().then(data => {
            setLoading(false);
            const navRoute =
                NOUN_PRO_TEAM_CHECKOUT.replace(":planType", planType)
                    .replace(":teamName", teamName)
                    .replace(":numSeats", teamSeats)
                    .replace(":teamUser", data.username) +
                (window.location.search || "");
            history.push(navRoute);
        });
    };

    if (loading) return <LoadingSpinner />;

    return (
        <SectionContainer
            bgColor={colors.secondary.orca}
            removeLeftRightPadding={browserWidth < breakpoints.beforeTablet.px}
        >
            <CheckoutPageHeading
                type="h1"
                headingColor={colors.primary.diamond}
                size="xl"
                alignment="center"
                bottomSpacing="4xl"
            >
                Start Your NounTeam Subscription
            </CheckoutPageHeading>

            <OffsetGrid lg={8} md={12} sm={12}>
                <SectionContainer
                    bgColor={colors.primary.snow}
                    topSpacing="2xl"
                    bottomSpacing="2xl"
                >
                    <OffsetGrid lg={6} md={8} sm={12}>
                        <Heading type="h2" size="sm" bottomSpacing="lg">
                            Tell us about your team
                        </Heading>

                        <FormInput
                            placeholderText={teamNamePlaceholder}
                            labelText={teamNamePlaceholder}
                            value={teamName}
                            onChange={setTeamName}
                            validation={nameValidation}
                        />

                        <FormInput
                            placeholderText={teamNumberPlaceholder}
                            labelText={teamNumberPlaceholder}
                            value={teamSeats}
                            onChange={setTeamSeats}
                            validation={numValidation}
                            type="number"
                            min={2}
                            max={251}
                        />

                        <ButtonContainer>
                            <ApplyButton
                                onClick={createTeamName}
                                isDisabled={
                                    !teamName ||
                                    !teamSeats ||
                                    teamSeats < 2 ||
                                    teamSeats > 251
                                }
                            >
                                Continue
                            </ApplyButton>
                            <CancelLink to={NOUN_PRO_TEAM_LANDING_PAGE}>
                                Cancel
                            </CancelLink>
                        </ButtonContainer>
                    </OffsetGrid>
                </SectionContainer>
            </OffsetGrid>
        </SectionContainer>
    );
};

export default TeamInfo;
